export interface EventColors {
  background: string;
  background_text: string;
  primary: string;
  primary_text: string;
  secondary: string;
  secondary_text: string;
}
